import { useStore } from "@features/common"
import { FisheyeDevilBottom, FisheyeDevilLeft } from "@features/seo-h1"

type ItWasPageProps = {
  title: string
}

export const SeoH1 = (props: ItWasPageProps) => {
  const { GlobalModel } = useStore()
  const { title } = props

  const subtitle = GlobalModel.getTemplate("seoH1.subtitle", false)

  return (
    <div className="flex flex-nowrap items-center py-3.5 tablet-s:py-0 tablet-s:px-8 desktop:px-20 bg-gray-50">
      <div className="shrink-0 h-full flex items-center tablet-s:items-end tablet-s:self-end w-[73px] tablet-s:w-[132px] desktop:w-[220px] tablet-s:-mb-1 desktop:pt-0 desktop:-mt-2.5">
        <FisheyeDevilLeft className="w-full block tablet-s:hidden" />
        <FisheyeDevilBottom className="w-full hidden tablet-s:block" />
      </div>
      <div className="flex-grow pr-3 pl-2 tablet-s:pl-4 tablet-s:pr-0 tablet-s:pt-8 tablet-s:pb-10">
        {subtitle && (
          <div className="text-sm text-gray-400 mb-1 tablet-s:mb-2 laptop:text-lg laptop:leading-6 ">
            {subtitle}
          </div>
        )}
        <h1 className="text-lg text-black uppercase tablet-s:leading-6 laptop:text-2xl">
          {title}
        </h1>
      </div>
    </div>
  )
}
